export const GAME_PHASES = {
  WELCOME: "welcome",
  PLAY: "play",
  RESULTS: "results",
  DECLINED: "declined",
};

/** @deprecated use GAME_PHASES — legacy step ids during migration */
export const LEGACY_STEP_TO_PHASE = {
  welcome: GAME_PHASES.WELCOME,
  vote: GAME_PHASES.PLAY,
  results: GAME_PHASES.RESULTS,
  declined: GAME_PHASES.DECLINED,
};

export function resolveInitialPhase(state) {
  if (state?.submitted || state?.votes_submitted) return GAME_PHASES.RESULTS;
  if (state?.opted_in === true || state?.favorite_dances_opted_in === true) return GAME_PHASES.PLAY;
  if (state?.favorite_dances_skipped) return GAME_PHASES.DECLINED;
  return GAME_PHASES.WELCOME;
}

export function phaseTitle(phase, { welcomeTitle, playTitle } = {}) {
  if (phase === GAME_PHASES.WELCOME) return welcomeTitle || "Welcome";
  if (phase === GAME_PHASES.RESULTS || phase === GAME_PHASES.DECLINED) return "Thanks";
  return playTitle || "Play";
}
